// extracted by mini-css-extract-plugin
export var badgeBorder = "GoogleReviewsBadge-module--badgeBorder--1f3e8";
export var badgeButton = "GoogleReviewsBadge-module--badgeButton--83c08";
export var badgeRoot = "GoogleReviewsBadge-module--badgeRoot--96fa2";
export var badgeStars = "GoogleReviewsBadge-module--badgeStars--744a1";
export var badgeStarsText = "GoogleReviewsBadge-module--badgeStarsText--11c42";
export var badgeText = "GoogleReviewsBadge-module--badgeText--ccfa1";
export var badgeTitle = "GoogleReviewsBadge-module--badgeTitle--6a7b7";
export var badgeWrapper = "GoogleReviewsBadge-module--badgeWrapper--b145c";
export var closeButton = "GoogleReviewsBadge-module--closeButton--b7bcf";
export var commentContent = "GoogleReviewsBadge-module--commentContent--7879f";
export var commentRoot = "GoogleReviewsBadge-module--commentRoot--87807";
export var commentText = "GoogleReviewsBadge-module--commentText--7713d";
export var commentsBody = "GoogleReviewsBadge-module--commentsBody--5ea1c";
export var commentsRoot = "GoogleReviewsBadge-module--commentsRoot--584b4";
export var commentsTitle = "GoogleReviewsBadge-module--commentsTitle--45ed2";
export var commentsTitleComponent = "GoogleReviewsBadge-module--commentsTitleComponent--2ea08";
export var footer = "GoogleReviewsBadge-module--footer--0d6dd";
export var googleIcon = "GoogleReviewsBadge-module--googleIcon--66711";
export var leftPadding = "GoogleReviewsBadge-module--leftPadding--de027";
export var profileImage = "GoogleReviewsBadge-module--profileImage--ad115";